import script from "./StoragePill.vue?vue&type=script&setup=true&lang=js"
export * from "./StoragePill.vue?vue&type=script&setup=true&lang=js"

import "./StoragePill.vue?vue&type=style&index=0&id=5d8f605d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d8f605d"]])

export default __exports__